// extracted by mini-css-extract-plugin
export default {"slideContainer":"NavList_slideContainer__f6ZrX","navList":"NavList_navList__iOGY-"};